// auto-generated by {apiBaseUrl}/tools/typescriptmodels
export class TextSearchPattern {
	public SearchString: string = "";
	public IsWildPrefix: boolean = false;
	public IsWildSuffix: boolean = false;
}